import LastChanceStatusTag from '@components/LastChanceStatusTag';
import { LastChanceProductListItem } from '@models/last-chance';
import { SelectProps } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

export interface LastChanceSelectOption {
  value: string;
  label: string;
  productTitle: string;
  optionName: string;
  partnerName: string;
  item: LastChanceProductListItem;
}

const formatDeadlineAt = (value?: string) => (value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '-');

export const buildLastChanceSelectOptions = (items: LastChanceProductListItem[]): LastChanceSelectOption[] => {
  return items.map((item) => {
    const productTitle = item.displayTitle || item.productName || '';
    const optionName = item.optionName?.trim() || '';
    const partnerName = item.partnerName?.trim() || '';
    const label = optionName ? `${productTitle} / ${optionName}` : productTitle;

    return {
      value: item.id,
      label: partnerName ? `[${partnerName}] ${label}` : label,
      productTitle,
      optionName,
      partnerName,
      item,
    };
  });
};

export const renderLastChanceSelectOption: NonNullable<SelectProps['optionRender']> = (option) => {
  const data = option.data as LastChanceSelectOption | undefined;
  if (!data) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 12,
        padding: '2px 0',
        lineHeight: 1.4,
        whiteSpace: 'normal',
      }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 500, wordBreak: 'break-word' }}>{data.productTitle}</div>
        {(data.optionName || data.partnerName) && (
          <div style={{ fontSize: 12, color: '#8c8c8c', wordBreak: 'break-word' }}>
            {[data.optionName, data.partnerName].filter(Boolean).join(' · ')}
          </div>
        )}
      </div>
      <div
        style={{
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 4,
          minWidth: 108,
        }}>
        <LastChanceStatusTag item={data.item} />
        <span style={{ fontSize: 11, color: '#8c8c8c', whiteSpace: 'nowrap' }}>
          마감 {formatDeadlineAt(data.item.deadlineAt)}
        </span>
      </div>
    </div>
  );
};

export const lastChanceSelectDropdownProps: Pick<
  SelectProps,
  'optionRender' | 'popupMatchSelectWidth' | 'listItemHeight'
> = {
  optionRender: renderLastChanceSelectOption,
  popupMatchSelectWidth: false,
  listItemHeight: 56,
};

export const getLastChanceContentTitle = (item: LastChanceProductListItem) => {
  const productTitle = item.displayTitle || item.productName || '';
  const optionName = item.optionName?.trim();
  return optionName ? `${productTitle} / ${optionName}` : productTitle;
};
